(function () {
  var NAME = 'al_gclid';
  var params = new URLSearchParams(window.location.search);
  var gclid = params.get('gclid');

  if (gclid) {
    var d = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000);
    document.cookie = NAME + '=' + encodeURIComponent(gclid) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    try { localStorage.setItem(NAME, gclid); } catch (e) {}
  }

  function getStored() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + NAME + '=([^;]*)'));
    if (m) return decodeURIComponent(m[1]);
    try { return localStorage.getItem(NAME); } catch (e) { return null; }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var field = document.getElementById('contact-gclid');
    var value = gclid || getStored();
    if (field && value) field.value = value;
  });
})();